// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__26J9Z","description":"PatientConsentPreview_description__2JEud"};